export default __webpack_public_path__ + "media/images/features/jtb/hero-bg-234359d76af70d2173c04c1c3f1a503d.jpg";